import * as React from "react"

const HorizontalLinePinLime = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 586.15 51.42" {...props}>
    <defs>
      <radialGradient
        id="gradient1"
        cx={2475.25}
        cy={-1320.94}
        r={81.79}
        gradientTransform="rotate(-90 1912.765 591.145)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#e3f769" />
        <stop offset={0.1} stopColor="#def651" />
        <stop offset={0.27} stopColor="#d8f42e" />
        <stop offset={0.43} stopColor="#d3f315" />
        <stop offset={0.58} stopColor="#d0f205" />
        <stop offset={0.7} stopColor="#cff200" />
        <stop offset={0.72} stopColor="#caed00" />
        <stop offset={0.83} stopColor="#b5d402" />
        <stop offset={0.92} stopColor="#a8c404" />
        <stop offset={1} stopColor="#a4bf04" />
      </radialGradient>
      <radialGradient
        id="gradient3"
        cx={2487.21}
        cy={-1275.83}
        r={36.48}
        gradientTransform="rotate(-90 1912.765 591.145)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#e3f76c" />
        <stop offset={0.11} stopColor="#def651" />
        <stop offset={0.28} stopColor="#d7f42e" />
        <stop offset={0.44} stopColor="#d3f315" />
        <stop offset={0.58} stopColor="#d0f205" />
        <stop offset={0.7} stopColor="#cff200" />
        <stop offset={0.72} stopColor="#caed00" />
        <stop offset={0.83} stopColor="#b5d402" />
        <stop offset={0.92} stopColor="#a8c404" />
        <stop offset={1} stopColor="#a4bf04" />
      </radialGradient>
      <linearGradient
        id="gradient2"
        x1={2491.05}
        y1={-1264.15}
        x2={2491.05}
        y2={-1327.65}
        gradientTransform="rotate(-90 1912.765 591.145)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#a4bf04" />
        <stop offset={0.18} stopColor="#a8c404" />
        <stop offset={0.39} stopColor="#b5d402" />
        <stop offset={0.63} stopColor="#caed00" />
        <stop offset={0.68} stopColor="#cff200" />
        <stop offset={0.74} stopColor="#d5f31f" />
        <stop offset={0.81} stopColor="#dbf53f" />
        <stop offset={0.88} stopColor="#dff656" />
        <stop offset={0.94} stopColor="#e2f764" />
        <stop offset={1} stopColor="#e3f769" />
      </linearGradient>
    </defs>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M85.7 32.11h150.46a7.71 7.71 0 0 0 9.83 0h153.07a7.71 7.71 0 0 0 9.83 0h151.33a13.65 13.65 0 1 0 0-11.84H408.89a7.68 7.68 0 0 0-9.83 0H246a7.68 7.68 0 0 0-9.83 0H85.7a13.65 13.65 0 1 0 0 11.84Zm323.82-5.92a5.55 5.55 0 1 1-5.52-5.54 5.55 5.55 0 0 1 5.52 5.54Zm-162.9 0a5.55 5.55 0 1 1-5.54-5.54 5.55 5.55 0 0 1 5.54 5.54ZM572.5 15.77a10.42 10.42 0 1 1-10.42 10.42 10.43 10.43 0 0 1 10.42-10.42ZM63 26.19a10.42 10.42 0 1 1 10.42 10.42A10.43 10.43 0 0 1 63 26.19Zm17.93 0a7.51 7.51 0 1 0-7.51 7.51 7.52 7.52 0 0 0 7.51-7.51Zm-13.24 0a5.73 5.73 0 1 1 5.73 5.73 5.74 5.74 0 0 1-5.73-5.73ZM572.5 33.7a7.51 7.51 0 1 0-7.5-7.51 7.51 7.51 0 0 0 7.5 7.51Zm0-13.24a5.73 5.73 0 1 1-5.73 5.73 5.74 5.74 0 0 1 5.73-5.73Z"
          style={{
            fill: "#9ea5ae",
          }}
        />
        <path
          d="M25.71 38.25c-6.5 0-12.27-6-12.27-12.54H0a25.66 25.66 0 0 0 36.73 23.2c18.68-8.09 36.73-23.24 36.73-23.24H38c0 6.54-5.79 12.58-12.29 12.58Z"
          style={{
            fill: "url(#gradient1)",
          }}
        />
        <path
          d="M25.71 0A25.71 25.71 0 0 0 0 25.71h13.14c0-6.5 6.07-12.54 12.57-12.54s12.76 6 12.76 12.54h35s-18-15.14-36.73-23.24A25.6 25.6 0 0 0 25.71 0Z"
          style={{
            fill: "url(#gradient2)",
          }}
        />
        <path
          d="M12 12a19.33 19.33 0 1 0 27.34 0A19.33 19.33 0 0 0 12 12Zm25.48 13.71a11.78 11.78 0 1 1-11.77-11.77 11.77 11.77 0 0 1 11.77 11.77Z"
          style={{
            fill: "url(#gradient3)",
          }}
        />
      </g>
    </g>
  </svg>
)

export default HorizontalLinePinLime
